import React, { useState } from 'react';
import { functionsInstance } from '../../firebase';
import { httpsCallable } from 'firebase/functions';

/**
 * WorkerRateConsumerModal – Modal for workers to rate and review the consumer/customer.
 * Props:
 *   job – booking/job object
 *   onClose – close modal
 *   onCompleted – callback after rating submitted successfully
 */
export default function WorkerRateConsumerModal({ job, onClose, onCompleted }) {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (rating === 0) {
      setError('Please select a rating.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await httpsCallable(functionsInstance, 'updateBookingStatus')({
        bookingId: job.id,
        action: 'worker_rate',
        extraArgs: { rating, reviewText: reviewText.trim() },
      });
      if (onCompleted) onCompleted();
    } catch (e) {
      setError(e?.message || 'Submission failed. Try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-bg">
      <div className="modal" style={{ padding: '24px 20px', borderRadius: '16px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 800, marginBottom: '8px', color: '#1F1144' }}>⭐ Rate Customer</h3>
        <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '16px' }}>
          Your rating and review will remain double-blind until both parties submit feedback or the 7-day window expires.
        </p>
        
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '16px', fontSize: '28px' }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              onClick={() => setRating(star)}
              style={{
                cursor: 'pointer',
                color: star <= rating ? '#7C3AED' : '#D1D5DB',
                transition: 'color 0.2s',
              }}
            >
              ★
            </span>
          ))}
        </div>

        <textarea
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
          placeholder="Write a review for the customer (optional)…"
          rows={3}
          style={{
            width: '100%',
            padding: '10px 12px',
            border: '1.5px solid #E5E7EB',
            borderRadius: '10px',
            fontSize: '14px',
            outline: 'none',
            resize: 'none',
            boxSizing: 'border-box',
            marginBottom: '16px',
          }}
        />

        {error && (
          <div style={{ color: '#DC2626', fontSize: '13px', fontWeight: 600, marginBottom: '16px', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <div className="modal-actions" style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={onClose}
            disabled={submitting}
            style={{
              flex: 1,
              padding: '10px',
              border: '1px solid #E5E7EB',
              borderRadius: '10px',
              background: '#FFF',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={submitting || rating === 0}
            style={{
              flex: 1,
              padding: '10px',
              border: 'none',
              borderRadius: '10px',
              background: rating === 0 ? '#E5E7EB' : '#7C3AED',
              color: rating === 0 ? '#9CA3AF' : '#FFF',
              cursor: rating === 0 ? 'not-allowed' : 'pointer',
              fontWeight: 600,
            }}
          >
            {submitting ? 'Submitting...' : 'Submit Rating'}
          </button>
        </div>
      </div>
    </div>
  );
}
